import React from "react";
import FormattedAsset from "../Utility/FormattedAsset";
import { Link } from "react-router-dom";
import classNames from "classnames";
import Translate from "react-translate-component";
import counterpart from "counterpart";
import utils from "common/utils";
import BlockTime from "./BlockTime";
import LinkToAccountById from "../Utility/LinkToAccountById";
import LinkToAssetById from "../Utility/LinkToAssetById";
import BindToChainState from "../Utility/BindToChainState";
import ChainTypes from "../Utility/ChainTypes";
import { ChainStore, ChainTypes as grapheneChainTypes } from "bitsharesjs";
import { connect } from "alt-react";
import SettingsStore from "stores/SettingsStore";
import PropTypes from "prop-types";
import { Tooltip } from "bitshares-ui-style-guide";
const {
  operations
} = grapheneChainTypes;
import opComponents from "./operations";

require("./operations.scss");

let ops = Object.keys(operations); // let listings = account_constants.account_listing;

class TransactionLabel extends React.Component {
  shouldComponentUpdate(nextProps) {
    return nextProps.color !== this.props.color || nextProps.type !== this.props.type;
  }

  render() {
    let trxTypes = counterpart.translate("transaction.trxTypes");
    let labelClass = classNames("label", this.props.color || "info");
    return /*#__PURE__*/React.createElement("span", {
      className: labelClass
    }, trxTypes[ops[this.props.type]]);
  }

}

class Row extends React.Component {
  static propTypes = {
    dynGlobalObject: ChainTypes.ChainObject.isRequired
  };
  static defaultProps = {
    dynGlobalObject: "2.1.0",
    tempComponent: "tr"
  };

  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    let {
      block,
      dynGlobalObject
    } = this.props;
    let last_irreversible_block_num = dynGlobalObject.get("last_irreversible_block_num");
    return nextProps.dynGlobalObject !== this.props.dynGlobalObject || block > last_irreversible_block_num || this.props.color !== nextProps.color;
  }

  render() {
    let {
      block,
      fee,
      color,
      type,
      hideOpLabel,
      hidePending
    } = this.props;
    let last_irreversible_block_num = this.props.dynGlobalObject.get("last_irreversible_block_num");
    let pending = null;

    if (!hidePending && block > last_irreversible_block_num) {
      pending = /*#__PURE__*/React.createElement("span", null, "(", /*#__PURE__*/React.createElement(Translate, {
        content: "operation.pending",
        blocks: block - last_irreversible_block_num
      }), ")");
    }

    fee.amount = parseInt(fee.amount, 10);
    return /*#__PURE__*/React.createElement("tr", null, this.props.includeOperationId ? /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "left"
      }
    }, this.props.operationId) : null, hideOpLabel ? null : /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "left"
      },
      className: "left-td column-hide-tiny"
    }, /*#__PURE__*/React.createElement(Tooltip, {
      placement: "bottom",
      title: counterpart.translate("tooltip.show_block", {
        block: utils.format_number(this.props.block, 0)
      })
    }, /*#__PURE__*/React.createElement(Link, {
      className: "inline-block",
      to: `/block/${this.props.block}/${this.props.txIndex}`
    }, /*#__PURE__*/React.createElement(TransactionLabel, {
      color: color,
      type: type
    })))), /*#__PURE__*/React.createElement("td", {
      style: {
        padding: "8px 5px",
        textAlign: "left"
      }
    }, /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("span", null, this.props.info)), /*#__PURE__*/React.createElement("div", {
      style: {
        fontSize: 14,
        paddingTop: 5
      }
    }, pending ? /*#__PURE__*/React.createElement("span", null, " - ", pending) : null)), !this.props.hideFee && /*#__PURE__*/React.createElement("td", {
      style: {
        textAlign: "left"
      }
    }, /*#__PURE__*/React.createElement(FormattedAsset, {
      amount: fee.amount,
      asset: fee.asset_id
    })), /*#__PURE__*/React.createElement("td", null, !this.props.hideDate ? /*#__PURE__*/React.createElement(BlockTime, {
      block_number: block,
      fullDate: this.props.fullDate
    }) : null));
  }

}

Row = BindToChainState(Row);

class Operation extends React.Component {
  state = {
    labelColor: "info"
  };
  static defaultProps = {
    op: [],
    current: "",
    block: null,
    hideOpLabel: false,
    csvExportMode: false
  };
  static propTypes = {
    op: PropTypes.array.isRequired,
    current: PropTypes.string,
    block: PropTypes.number,
    csvExportMode: PropTypes.bool
  };

  UNSAFE_componentWillReceiveProps(np) {
    if (np.marketDirections !== this.props.marketDirections) {
      this.forceUpdate();
    }
  }

  shouldComponentUpdate(nextProps, nextState) {
    if (!this.props.op || !nextProps.op) {
      return false;
    }

    return !utils.are_equal_shallow(nextProps.op[1], this.props.op[1]) || nextProps.marketDirections !== this.props.marketDirections || this.state.labelColor !== nextState.labelColor;
  }

  linkToAccount(name_or_id) {
    if (!name_or_id) return /*#__PURE__*/React.createElement("span", null, "-");
    return utils.is_object_id(name_or_id) ? /*#__PURE__*/React.createElement(LinkToAccountById, {
      account: name_or_id
    }) : /*#__PURE__*/React.createElement(Link, {
      to: `/account/${name_or_id}`
    }, name_or_id);
  }

  linkToAsset(symbol_or_id) {
    if (!symbol_or_id) return /*#__PURE__*/React.createElement("span", null, "-");
    return utils.is_object_id(symbol_or_id) ? /*#__PURE__*/React.createElement(LinkToAssetById, {
      asset: symbol_or_id
    }) : /*#__PURE__*/React.createElement(Link, {
      to: `/asset/${symbol_or_id}`
    }, symbol_or_id);
  }

  changeColor = newColor => {
    const {
      labelColor
    } = this.state;

    if (labelColor !== newColor) {
      this.setState({
        labelColor: newColor
      });
    }
  };

  render() {
    let {
      op,
      block
    } = this.props;
    let line = null,
        column = null;
    column = opComponents(ops[op[0]], this.props, {
      fromComponent: "operation",
      linkToAccount: this.linkToAccount,
      linkToAsset: this.linkToAsset,
      changeColor: this.changeColor
    });

    if (this.props.csvExportMode) {
      const globalObject = ChainStore.getObject("2.0.0");
      const dynGlobalObject = ChainStore.getObject("2.1.0");
      const block_time = utils.calc_block_time(block, globalObject, dynGlobalObject);
      return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement("div", null, block_time ? block_time.toLocaleString() : ""), /*#__PURE__*/React.createElement("div", null, ops[op[0]]), /*#__PURE__*/React.createElement("div", null, column), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(FormattedAsset, {
        amount: parseInt(op[1].fee.amount, 10),
        asset: op[1].fee.asset_id
      })));
    }

    line = column ? /*#__PURE__*/React.createElement(Row, {
      operationId: this.props.operationId,
      txIndex: this.props.txIndex,
      includeOperationId: this.props.includeOperationId,
      block: block,
      type: op[0],
      color: this.state.labelColor,
      fee: op[1].fee,
      hideOpLabel: this.props.hideOpLabel,
      hideDate: this.props.hideDate,
      info: column,
      hideFee: this.props.hideFee,
      hidePending: this.props.hidePending,
      fullDate: this.props.fullDate
    }) : null;
    return line ? line : /*#__PURE__*/React.createElement("tr", null);
  }

}

Operation = connect(Operation, {
  listenTo() {
    return [SettingsStore];
  },

  getProps() {
    return {
      marketDirections: SettingsStore.getState().marketDirections
    };
  }

});
export default Operation;